module.exports = __webpack_public_path__ + "img/ot-wxbtrfly.31895b99.png";